import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const FAQItem = ({
  question,
  answer
}: {
  question: string;
  answer: string;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-gray-200 last:border-0" data-id="element-1">
      <button className="w-full py-6 flex justify-between items-center text-left focus:outline-none" onClick={() => setIsOpen(!isOpen)} data-id="element-2">
        <span className="text-lg font-medium text-dark-900 pr-8" data-id="element-3">
          {question}
        </span>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.2
      }} data-id="element-4">
          <ChevronDown className="text-coral-500" data-id="element-5" />
        </motion.div>
      </button>
      <AnimatePresence data-id="element-6">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} className="overflow-hidden" data-id="element-7">
            <p className="pb-6 text-gray-600 leading-relaxed" data-id="element-8">{answer}</p>
          </motion.div>}
      </AnimatePresence>
    </div>;
};
export function FAQSection() {
  const faqs = [{
    question: '¿Necesito comprar suplementos o equipos especiales?',
    answer: 'No. El Protocolo Cortisol OFF está diseñado para implementarse con lo que ya tienes en casa. Solo necesitas seguir el plan de 14 días con hábitos simples y accesibles.'
  }, {
    question: '¿Funciona si tengo más de 45 años?',
    answer: 'Especialmente para ti. El método Circadian Stacking está diseñado para mujeres en perimenopusia y menopausia, donde el cortisol juega un papel clave en la inflamación y el agotamiento.'
  }, {
    question: '¿Cuándo recibo el acceso?',
    answer: 'Inmediatamente después de tu pago. Recibirás un email con el enlace de descarga en menos de 5 minutos.'
  }, {
    question: '¿Qué pasa si no funciona para mí?',
    answer: 'Tienes 7 días de garantía total. Si no ves resultados, te devolvemos el 100% de tu dinero sin preguntas.'
  }, {
    question: '¿Es seguro el pago?',
    answer: 'Sí. El pago se procesa a través de Hotmart, una plataforma 100% segura con encriptación SSL. Aceptamos tarjetas de crédito, débito y PayPal.'
  }];
  return <section className="py-20 bg-white" data-id="element-9">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-10">
        <div className="text-center mb-12" data-id="element-11">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-dark-900" data-id="element-12">
            Preguntas Frecuentes
          </h2>
        </div>

        <div className="bg-cream-50 rounded-2xl p-6 md:p-8 shadow-sm border border-cream-200" data-id="element-13">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} data-id="element-14" />)}
        </div>
      </div>
    </section>;
}